import { Alerta, Button, Row, Select } from "@/components";
import type { VistaComo } from "@/lib/api";
import { useFranjaVerComo } from "./useFranjaVerComo";

export interface FranjaVerComoProps {
  fid: number;
  vista: VistaComo;
  onRecargarUsuario: () => Promise<void>;
}

/** Arriba de todo mientras el admin ve la app como un fiduciante: a quién (se puede cambiar ahí mismo), que es sólo lectura y cómo salir. */
export function FranjaVerComo({ fid, vista, onRecargarUsuario }: FranjaVerComoProps) {
  const t = useFranjaVerComo(fid, onRecargarUsuario);
  return (
    <div role="region" aria-label="Ver como fiduciante" className="mb-6 rounded-control bg-alerta-suave px-4 py-3 text-alerta">
      <Row justificar="entre" alinear="fin" envolver espacio={3}>
        <div className="min-w-56 flex-1 sm:max-w-sm">
          <Select
            etiqueta="Estás viendo como · sólo lectura"
            opciones={t.opciones.length > 0 ? t.opciones : [{ valor: String(vista.fiduciante_id), etiqueta: vista.fiduciante_nombre }]}
            valor={String(vista.fiduciante_id)}
            onCambio={(v) => v !== String(vista.fiduciante_id) && void t.cambiar(v)}
            deshabilitado={t.cambiando}
          />
        </div>
        <Button variante="secundario" tamanio="sm" cargando={t.saliendo} onClick={() => void t.salir()}>
          Salir
        </Button>
      </Row>
      <Alerta texto={t.error} />
    </div>
  );
}
